import { Directive } from '@angular/core';
import { DP_DASHBOARD_DEFAULT_PLACEHOLDERS_PROVIDER } from 'data-processor/lib/widget-library/dashboard/services/default-placeholders.provider';

@Directive({
    selector: '[dpProvideDefaultPlaceholders]',
    providers: [DP_DASHBOARD_DEFAULT_PLACEHOLDERS_PROVIDER],
})
export class ProvideDefaultPlaceholdersDirective {}
